import { reactive } from 'vue'
import almacen from '@/services/almacen'

// Estado reactivo para el tema
const state = reactive({
  isDarkMode: false,
  userPreference: null // 'light', 'dark', or null (auto)
})

// Theme Manager
const themeManager = {
  // Getters
  get isDarkMode() {
    return state.isDarkMode
  },

  get themeClass() {
    return state.isDarkMode ? 'dark-theme' : 'light-theme'
  },

  get userPreference() {
    return state.userPreference
  },

  // Methods
  toggleTheme() {
    // Si está en modo auto, cambiar a manual
    if (state.userPreference === null) {
      state.userPreference = state.isDarkMode ? 'light' : 'dark'
    } else {
      // Cambiar entre light/dark manual
      state.userPreference = state.userPreference === 'dark' ? 'light' : 'dark'
    }
    this.updateTheme()
    this.saveToStorage()
  },

  setTheme(theme) {
    // 'auto', 'light', 'dark'
    if (theme === 'auto') {
      state.userPreference = null
    } else {
      state.userPreference = theme
    }
    this.updateTheme()
    this.saveToStorage()
  },

  updateTheme() {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

    if (state.userPreference === null) {
      // Modo automático - seguir preferencia del sistema
      state.isDarkMode = prefersDark
    } else {
      // Modo manual - usar preferencia del usuario
      state.isDarkMode = state.userPreference === 'dark'
    }

    this.applyTheme()
  },

  applyTheme() {
    if (state.isDarkMode) {
      document.documentElement.classList.add('dark-theme')
      document.documentElement.classList.remove('light-theme')
    } else {
      document.documentElement.classList.add('light-theme')
      document.documentElement.classList.remove('dark-theme')
    }
  },

  saveToStorage() {
    const preference = state.userPreference === null ? 'auto' : state.userPreference
    almacen.setItem('sicecom-theme', preference)
  },

  loadFromStorage() {
    const savedTheme = almacen.getItem('sicecom-theme')

    if (savedTheme === 'auto' || savedTheme === null) {
      state.userPreference = null
    } else if (savedTheme === 'light' || savedTheme === 'dark') {
      state.userPreference = savedTheme
    } else {
      // Valor inválido, usar auto
      state.userPreference = null
    }

    this.updateTheme()
  },

  init() {
    this.loadFromStorage()

    // Escuchar cambios en la preferencia del sistema
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (state.userPreference === null) {
        // Solo actualizar si está en modo automático
        this.updateTheme()
      }
    })
  }
}

export default themeManager